import * as React from 'react';
import { connect } from 'react-redux';
import { PRODUCT_BLING, PRODUCT_CAR_WARRANTY, PRODUCT_CODE_RED, PRODUCT_COMPREHENSIVE_CAR, PRODUCT_PORTABLE_POSSESSIONS, PRODUCT_BUILDING, PRODUCT_HOME_CONTENT } from '../../../constants/constants';
import CarQuotation from "./CarQuotation/CarQuotation"
import PortableQuotation from "./PortableQuotation/PortableQuotation"
import WarrantyQuotation from "./WarrantyQuotation/WarrantyQuotation"
import CodeRedQuotation from "./CodeRedQuotation/CodeRedQuotation"
import CellphoneQuotation from "./CellphoneQuotation/CellphoneQuotation"
import BuildingQuotation from "./BuildingQuotation/BuildingQuotation"
import HomeContentQuotation from "./HomeContentQuotation/HomeContentQuotation"

class QuotationSelector extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        }
    }

    public render() {
      return (
            <>
              {this.props.sales.quoteType === PRODUCT_COMPREHENSIVE_CAR &&
                  <CarQuotation />}
              {this.props.sales.quoteType === PRODUCT_PORTABLE_POSSESSIONS &&
                  <PortableQuotation />}
              {this.props.sales.quoteType === PRODUCT_BLING &&
                  <CellphoneQuotation />}
              {this.props.sales.quoteType === PRODUCT_CAR_WARRANTY &&
                  <WarrantyQuotation />}
              {this.props.sales.quoteType === PRODUCT_CODE_RED &&
                  <CodeRedQuotation />}
              {this.props.sales.quoteType === PRODUCT_BUILDING &&
                  <BuildingQuotation />}
              {this.props.sales.quoteType === PRODUCT_HOME_CONTENT &&
                  <HomeContentQuotation />}
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
         
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationSelector);